// Create acronym from user's first name and last name
export const getNameAcronym = (name: string | undefined): string | null => {
  const str = name || ''
  const matches = str.match(/\b(\w)/g)

  return matches && matches.join('')
}

export const isEmailValid = (
  email: string | undefined
): boolean | undefined => {
  const tester =
    // eslint-disable-next-line no-useless-escape
    /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/
  if (email) {
    return tester.test(email)
  }
}

/**
 * getUrlSubDomain is used to parse the url to get the sub-domain
 */
export const getUrlSubDomain = import.meta.env.VITE_APP_SUB_DOMAIN

export const inviteUrl = `${window.location.protocol}//${window.location.hostname}/authentication/invitation/?token=`
